// Adapter for TRUENDO injecting its banner and settings panel directly under
// <body>. If TRUENDO gains a configurable mount point, render it into a
// server-side <div id="truendo-root" data-turbo-permanent></div> instead and
// delete this listener.
const PANEL_SCRIPT_SELECTOR = "#truendoPrivacyPanel"
const CONTAINER_SELECTOR = "#truendo_container"

function directBodyChild(body, element) {
  let root = element

  while (root?.parentElement && root.parentElement !== body) {
    root = root.parentElement
  }

  return root?.parentElement === body ? root : null
}

function rootsIn(body) {
  const panelScript = body.querySelector(PANEL_SCRIPT_SELECTOR)
  const containerRoot = directBodyChild(body, body.querySelector(CONTAINER_SELECTOR))

  return [...new Set([panelScript, containerRoot].filter(Boolean))]
}

document.addEventListener("turbo:before-render", (event) => {
  const liveRoots = rootsIn(document.body)
  if (liveRoots.length === 0) return

  rootsIn(event.detail.newBody).forEach((root) => root.remove())

  liveRoots.forEach((root) => {
    if (root.matches(PANEL_SCRIPT_SELECTOR)) root.dataset.turboEval = "false"
    event.detail.newBody.append(root)
  })
})
